<template>
  <div>
    <v-row>
      <v-col :lg="10" :md="9" :sm="9" :xs="12">
        <v-text-field
          v-model="plate"
          v-mask="'AAA#X##'"
          label="Placa do veículo*"
          outlined
          dense
          clearable
          :error-messages="errorMessage"
          @keyup.enter="addPlate"
          @input="plate = plate ? plate.toUpperCase() : plate"
        />
      </v-col>
      <v-col :lg="2" :md="3" :sm="3" :xs="12">
        <v-btn depressed color="primary" block @click="addPlate">
          <v-icon left>add</v-icon>
          Adicionar
        </v-btn>
      </v-col>
    </v-row>

    <v-chip-group v-if="plates.length" column class="mt-0 mb-2">
      <v-chip
        v-for="(p, index) in plates"
        :key="index"
        close
        color="success"
        outlined
        @click:close="removePlate(index)"
      >
        {{ p.plate }}
      </v-chip>
    </v-chip-group>
  </div>
</template>

<script>
import { mask } from 'vue-the-mask';

export default {
  name: 'OrderVehicleAdd',

  directives: { mask },

  props: {
    value: {
      type: Array,
      default: () => []
    }
  },

  data: () => ({
    plate: '',
    plates: [],
    errorMessage: null,
  }),

  watch: {
    value(val) {
      this.plates = val ? [...val] : [];
    }
  },

  mounted() {
    this.plates = this.value ? [...this.value] : [];
  },

  methods: {
    addPlate() {
      const normalized = (this.plate || '').trim().toUpperCase();

      if (!/^[A-Z]{3}\d[A-Z0-9]\d{2}$/.test(normalized)) {
        this.errorMessage = 'Informe uma placa válida';
        return;
      }

      if (this.plates.some(p => p.plate === normalized)) {
        this.errorMessage = 'Essa placa já foi adicionada';
        return;
      }

      this.errorMessage = null;
      this.plates.push({ id: Date.now(), plate: normalized });
      this.plate = '';
      this.$emit('input', [...this.plates]);
    },

    removePlate(index) {
      this.plates.splice(index, 1);
      this.$emit('input', [...this.plates]);
    },
  },
};
</script>
